import React from "react";
import { useSelector } from "react-redux";

const Rules = () => {
  const { sparcRuleList } = useSelector((state) => state?.getStartReducer);

  return (
    <>
      <div class="row">
        {sparcRuleList.map((rule) => (
          <div className="col-lg-4 col-md-6 mb-4" key={rule.id}>
            <div
              href="#"
              className="ct_spark_card"
              style={{ backgroundColor: rule.container_color }}
            >
              <div className="ct_spark_content">
                <h4>{rule.sparc_rule_title}</h4>
                <div
                  dangerouslySetInnerHTML={{
                    __html: rule.sparc_rule_description,
                  }}
                ></div>
              </div>
            </div>
          </div>
        ))}
        {/* <div class="col-lg-4 col-md-6 mb-4">
              <a
                href="#"
                class="ct_spark_card"
                style={{ backgroundColor: "var(---dark_blue)" }}
              >
                <div class="ct_spark_content">
                  <h4>SPARC Tournament Procedures</h4>
                  <p>How Tournaments are run</p>
                </div>
              </a>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
              <a
                href="#"
                class="ct_spark_card"
                 style={{ backgroundColor: "var(---darkyellow)" }}
              >
                <div class="ct_spark_content">
                  <h4>SPARC Match Rules</h4>
                  <p>SPARC Match Rules</p>
                </div>
              </a>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
              <a
                href="#"
                class="ct_spark_card"
                style={{backgroundColor: "var(---ct_dark_brown)"}}
              >
                <div class="ct_spark_content">
                  <h4>SPARC Judging Guidelines</h4>
                  <p>How to judge a robot match</p>
                </div>
              </a>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
              <a
                href="#"
                class="ct_spark_card"
                 style={{ backgroundColor: "var(---darkyellow)" }}
              >
                <div class="ct_spark_content">
                  <h4>SPARC Robot Construction Specifications</h4>
                  <p>Build a rules compliant robot</p>
                </div>
              </a>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
              <div
                class="ct_spark_card"
                style={{backgroundColor: "var(---ct_dark_brown)"}}
              >
                <div class="ct_spark_content">
                  <h4>SPARC Arena Construction Best Practices</h4>
                  <p>Guidelines for building a safe arena</p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
              <a
                href="#"
                class="ct_spark_card"
                style={{ backgroundColor: "var(---dark_blue)" }}
              >
                <div class="ct_spark_content">
                  <h4>More Resources</h4>
                  <p>Explore the Getting Started Information</p>
                </div>
              </a>
            </div> */}
      </div>
    </>
  );
};

export default Rules;
